<template>
    <v-container>
        <v-row no-gutters>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <h1>GST</h1>
            </v-col>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <v-switch
                v-model="gmwswitch"
                color="red"
                label="GMW"
                hide-details
                ></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            
        </v-row>
        <v-row>
            <v-col cols="12" sm="2">
                <v-autocomplete
                    label="Company"
                    v-model="com"
                    :items="companies"
                    density="default"
                    placeholder="Company"
                    auto-select-first
                    item-props
                    clearable   
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2">
                <v-text-field label="Date" v-model="date" type='date' required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-btn color="purple" @click="gstdata()" >
                            GSTR 3B
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="success" @click="downloadb2bjson()" >
                            GSTR1 B2B
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div v-if="(com != '') && (date != '') && (showgstdata)">
            
            <v-tabs
                v-model="tab"
                bg-color="transparent"
                color="basil"
                grow
                >
                <v-tab
                    v-for="item in items"
                    :key="item"
                    :text="item.name"
                    :value="item"
                ></v-tab>
            </v-tabs>
            <v-tabs-window v-model="tab">
                <v-tabs-window-item
                    v-for="item in items"
                    :key="item"
                    :value="item"
                >
                
                <GSTR1 v-if="item.content == 'gstr1'" :gmwswitch="gmwswitch" :company="com" :date="date" :billdata="billdata" :cndata="cndata"/>
                <GSTR3B v-if="item.content == 'gstr3b'" :gmwswitch="gmwswitch" :company="com" :date="date" :billdata="billdata" :cndata="cndata" :purchasedata="purchasedata"/>
                
            </v-tabs-window-item>
            </v-tabs-window>
            
        </div>
        
        <div v-if="showMessage">
            <ShowError />
        </div>
    </v-container>

</template>

<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
    import ShowError from '@/components/Showerror'
    import { useAuthStore } from '@/stores/AuthStore'
    import GSTService from '@/services/GstService'
    import BillService from '@/services/BillService'
    import PurchaseService from '@/services/PurchaseService'
    import GSTR1 from '@/views/gst/gstr1'
    import GSTR3B from '@/views/gst/gstr3b'
    import moment from 'moment';

    const authStore = useAuthStore()

    var gmwswitch = ref(authStore.gmswitch)
    var companies = ref((gmwswitch.value) ? ['GM'] : ['GM','SM'])
    var com = ref('')
    var date = ref('')

    var showgstdata = ref(false)

    // var com = ref('GM')
    // var date = ref('2024-12-12')

    var startdate = ref('');
    var enddate = ref('');

    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    var tab = ref('gst')
    var items = ref([
        {
            name : 'GSTR 3B',
            content: 'gstr3b',
            text: 'GSTR 3B content'
        },
        {
            name : 'GSTR 1',
            content: 'gstr1',
            text: 'GSTR 1 content'
        }, 
    ])

    var billdata = ref([])
    var purchasedata = ref([])
    var cndata = ref([])

    async function gstdata(){
        await getbilldata()
        await getpurchasedata()
        await getcndata()
        showgstdata.value = true
    }

    async function downloadb2bjson(){
        try{
            var gstdata = gmwswitch.value ? (await GSTService.getb2bjsongmw(date.value,com.value)).data : (await GSTService.getb2bjson(date.value,com.value)).data
            console.log(gstdata)
            var gm_or_w = (gmwswitch.value) ? 'GMW' : 'GM'
            var filename = gm_or_w+'-'+com.value+'-'+date.value+".json"
            let text = JSON.stringify(gstdata);
            let element = document.createElement('a');
            element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }

    }

    async function getbilldata(){
        var company = com.value
        var con = (company == 'GM') ? 'GM1' : 'SM1'
        try{
            var gstdata = gmwswitch.value ? (await GSTService.getgstdatagmw(startdate.value,enddate.value,con)).data : (await GSTService.getgstdata(startdate.value,enddate.value,con)).data
            billdata.value = gstdata
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
    }

    async function getpurchasedata(){
        var purchase = (gmwswitch.value) ? await getpurchasegmw() : ((com.value == 'GM') ? await getpurchasegm() : await getpurchasesm())
        purchasedata.value = purchase
    }

    async function getpurchasegm(){
        var purchase = []
        try{
            var purchases = (await PurchaseService.getpurchasedata(startdate.value,enddate.value)).data
            //billdata.value = gstdata
            var purchasemapped = purchases.map(v => ({
                gstno: v.vendor.vgstno,
                billno: v.billno,
                billdate: v.billdate,
                party: v.vname,
                taxable: v.pur_taxable,
                igst: v.pur_igst,
                cgst: v.pur_cgst,
                sgst: v.pur_sgst,
                billamount: v.amnt
            }))
            purchase = purchasemapped
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return purchase
    }

    async function getpurchasesm(){
        var purchase = []
        try{
            var purchases = (await BillService.getsminputbills(startdate.value,enddate.value)).data
            //billdata.value = gstdata
            var purchasemapped = purchases.map(v => ({
                gstno: '19AAVFG1029Q1ZM',
                billno: v.billno,
                billdate: v.billdate,
                party: 'G.M.Pharmaceuticals',
                taxable: v.total,
                igst: v.bills_igst,
                cgst: v.bills_cgst,
                sgst: v.bills_sgst,
                billamount: v.billamount
            }))
            purchase = purchasemapped
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return purchase
    }

    async function getpurchasegmw(){
        var purchase = []
        try{
            var purchases = (await PurchaseService.getpurchasedatagmw(startdate.value,enddate.value)).data
            //billdata.value = gstdata
            console.log("Purchase from purchase gmw")
            console.log(purchases)
            var purchasemapped = purchases.map(v => ({
                gstno: v.vendor.vgstno,
                billno: v.ps_chbillno,
                billdate: v.ps_chdate,
                party: v.ps_vname,
                taxable: v.ps_taxable,
                igst: v.ps_igst,
                cgst: v.ps_cgst,
                sgst: v.ps_sgst,
                billamount: v.ps_billamount
            }))
            purchase = purchasemapped
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return purchase
    }


    async function getcndata(){
        try{
            var gstdata = gmwswitch.value ? (await GSTService.getcreditnotesgmw(startdate.value,enddate.value,com.value)).data : (await GSTService.getcreditnotes(startdate.value,enddate.value,com.value)).data
            cndata.value = gstdata
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
    }

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        companies.value = (gmwswitch.value) ? ['GM'] : ['GM','SM']
        if(showgstdata.value){
            //showgstdata.value = false
            await gstdata()
        }
    })

    watch(date, async(val)=>{
        startdate.value = moment(date.value).startOf('month').format('YYYY-MM-DD');
        enddate.value = moment(date.value).endOf('month').format("YYYY-MM-DD");
    })

</script>

<style>
/* Helper classes */
.bg-basil {
  background-color: #FFFBE6 !important;
}
.text-basil {
  color: #356859 !important;
}
</style>